import { render, staticRenderFns } from "./sublist.vue?vue&type=template&id=cc4607c8&scoped=true&"
import script from "./sublist.vue?vue&type=script&lang=js&"
export * from "./sublist.vue?vue&type=script&lang=js&"
import style0 from "../styles.scss?vue&type=style&index=0&id=cc4607c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4607c8",
  null
  
)

export default component.exports